<template>
  <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.617 3H5.383C3.315 3 1.64 4.79 1.64 7v10c0 2.21 1.676 4 3.744 4h11.234c2.069 0 3.745-1.79 3.745-4V7c0-2.21-1.676-4-3.745-4ZM7.256 1v4M14.744 1v4M1.639 9h18.723"
      stroke="#153D49"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
